import { createFetch } from "../../../../helpers/fetch/FetchRequest";
import { getCookie, scrollToAnchor } from "../../../../helpers/common";
import { dispatchNotification } from "../../../../layouts/app/components/notificationSystem/notifications";
import { onAuthError, saveLocationForRedirect } from "../../../../helpers/data/get/user";
import Router from "next/router";
import { store } from "../../../../redux/store";
import { wipeModalState } from "../../../../redux/actions/ModalActions";
import {
    // setDeploymentResponseMessages,
    updateDeployRequestLoading,
    updateInputError
} from "../../../../redux/actions/DeploymentActions";
// import { CUSTOM_STACK_NAME } from "../../../../settings/builder";
import { ANCHOR_CLOUD } from "../../_components/cloud/CloudForm";
import { NAV_DASHBOARD } from "../../../../settings/navigation";
import {
    API_DEPLOYMENT_CREATE_EXTERNAL,
    API_DEPLOYMENT_VALIDATE_EXTERNAL
} from "../../../../settings/endpoints/user";
import { API_REPEAT_PAYMENT_EXTERNAL } from "../../../../settings/endpoints/payment";
import { USER_ACCESS_TOKEN_NAME } from "../../../../settings/global";

export function collectDeploymentData(paymentData, custom) {

    const {deployment, userData} = store.getState();
    const {
        bodyBuilder, bodyStack, bodyServer, bodyCloud,
        currentCloud, currentApp, debug
    } = deployment;
    let data = {
        ...bodyStack,
        ...bodyServer,
        ...bodyCloud,
        ...{
            provider: currentCloud?.code,
            stack_code: !custom ? currentApp.code : 'custom-stack',
            selected_plan: userData.user.plan.code,
            version: currentApp.version,
        },
        ...(!!custom ? {custom: bodyBuilder} : {})
    };

    if (!!paymentData) {
        data.payment_type = !!paymentData.selectedType ? paymentData.selectedType : null;
        data.payment_method = !!paymentData.selectedMethod ? paymentData.selectedMethod : null;
        data.selected_plan = !!paymentData.selectedPlan ? paymentData.selectedPlan : null;
        data.currency = !!paymentData.selectedCurrency ? paymentData.selectedCurrency : null;
    }

    if (!!debug.removeProvider) delete data.provider;
    if (!!debug.removeStackCode) delete data.stack_code;
    if (!!debug.removeSelectedPlan) delete data.selected_plan;

    return data
}

function notify(response, message, type) {
    let {error, responseBody} = response;
    message = !!message ? message : 'Something went wrong. Please, try again later or contact support';
    type = !!type ? type : 'error';
    dispatchNotification({
        message: message,
        url: API_DEPLOYMENT_VALIDATE_EXTERNAL,
        type: type, status: error.status, requestTitle: 'Payment validation', responseContent: responseBody
    });
}

export function onCommonDeployError(response, custom) {
    const {dispatch} = store;

    switch (response.error.status) {
        case 400:
            switch (true) {
                case response.responseBody._error === 'Wrong provider credentials':
                    const {currentCloud, messagesResponse} = store.getState().deployment;
                    scrollToAnchor(ANCHOR_CLOUD, undefined, true, custom ? 'builder-container' : undefined);
                    const form = currentCloud?.config?.cloudForm;
                    if (!!form?.length) {
                        const fields = form.filter(i => i.type === 'field' && !!i.required);
                        if (!!fields.length) {
                            let errors = {};
                            fields.map(f => errors[f.name] = 'Wrong provider credentials');
                            // legacy
                            store.dispatch(updateInputError(errors));
                            // new
                            // store.dispatch(setDeploymentResponseMessages([
                            //     ...messagesResponse,
                            //     ...fields.map(f => ({
                            //         message: 'Wrong provider credentials',
                            //         type: 'warning',
                            //         container: ANCHOR_CLOUD,
                            //         block: 'cloud-form',
                            //         target: `cloud-input=${f.id}`,
                            //     })),
                            // ]));
                            setTimeout(() => {
                                const field = document.getElementById(`anchor-${fields[0].name}`);
                                if (field) field.focus();
                            }, 400)
                        }
                    }
                    break;
                case typeof response.responseBody?._error === 'object':

                    if (typeof response.responseBody?._error?.message === 'string') {
                        notify(response, response.responseBody?._error?.message);
                    } else if (typeof response.responseBody?._error?.message === 'object') {
                        notify(response, 'Some of provided data is invalid. Please check page  for errors.');
                        dispatch(wipeModalState());

                        let collectedErrors = {};
                        let elementInDOM = undefined;
                        let keyElement = undefined;

                        Object.keys(response.responseBody?._error?.message).map(key => {
                            let element = document.getElementById(`anchor-${key}`);
                            if (!!element && !elementInDOM) {
                                elementInDOM = element;
                                keyElement = key;
                            }
                            collectedErrors[key] = response.responseBody?._error?.message[key];
                        });

                        if (!!elementInDOM) {
                            scrollToAnchor(`anchor-${keyElement}`, null, true, custom ? 'builder-container' : undefined);
                            if (!!elementInDOM.focus) setTimeout(() => elementInDOM.focus(), 100)
                        }

                        dispatch(updateInputError(collectedErrors));
                    }
                    break;
                case !!response.responseBody?.message?.length && typeof response.responseBody?.message === 'string':
                    notify(response, response.responseBody?.message);
                    break;
                case typeof response.responseBody?._error === 'string':
                    notify(response, response.responseBody?._error);
                    break;
                case !!response.responseBody?.length && typeof response.responseBody === 'string':
                    notify(response, response.responseBody);
                    break;
                default:
                    notify(response, 'Provided data is invalid. If you do not see the reason, please contact support.');
                    break;
            }
            break;
        case 401: // Unauthorized
            saveLocationForRedirect();
            onAuthError();
            break;
        case 403:
            notify(response, response.responseBody?._error, 'error');
            break;
        default:
            notify(response);
            break;
    }
}

export function setDeploymentRequestLoading(bool) {
    store.dispatch(updateDeployRequestLoading(bool))
}

export function onDeploy({
                             // setDeploymentRequestLoading: setDeploymentRequestLoading,
                             repeatPayment: repeatPayment,
                             paymentData: paymentData,
                             onSuccess: onSuccess,
                             onError: onError,
                             // custom,
                         }) {

    const collectedData = collectDeploymentData(paymentData/*, custom*/);
    let url = API_DEPLOYMENT_CREATE_EXTERNAL + 'init';

    // if (custom) url = URL_STACK_CUSTOM_DEPLOY;

    if (!!repeatPayment && !!collectedData.installation_id) {
        url = API_REPEAT_PAYMENT_EXTERNAL + collectedData.installation_id
    }

    setDeploymentRequestLoading(true);
    createFetch({
        URL: url,
        method: 'POST',
        headers: {
            'Authorization': "Bearer " + getCookie(USER_ACCESS_TOKEN_NAME),
            'Content-Type': 'application/json',
        },
        body: collectedData,
        onSuccess: response => {
            setDeploymentRequestLoading(false);
            if (onSuccess) onSuccess(response);
            Router.push(NAV_DASHBOARD);
        },
        onError: response => {

            setDeploymentRequestLoading(false);
            if (onError) onError(response);

            let {error, responseBody} = response;

            switch (error.status) {
                case 402:
                    if (!!responseBody['payment_url']) {
                        setDeploymentRequestLoading(true);
                        window.location.assign(responseBody['payment_url']);
                    }
                    break;
                default:
                    onCommonDeployError(response);
                    return;
            }
        },
    });
}

